import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Table, Form } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    GET_ALL_FAQS_ROUTE,
    CREATE_FAQ_ROUTE,
    UPDATE_FAQ_ROUTE,
    DELETE_FAQ_ROUTE,
} from "../../services/apiRoutes";

const FAQs = () => {
    const [faqs, setFaqs] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('add'); // 'add' or 'edit'
    const [formData, setFormData] = useState({ title: '', desc: '', order: 0, id: null });

    const token = localStorage.getItem('accessToken');
    const authHeader = { Authorization: `Bearer ${token}` };

    const loadFaqs = () => {
        axios.get(GET_ALL_FAQS_ROUTE, { headers: authHeader })
            .then(response => setFaqs(response.data.faqs || []))
            .catch(error => {
                console.error("Error fetching FAQs:", error);
                toast.error("Failed to load FAQs.");
            });
    };

    useEffect(() => { loadFaqs(); }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleOpenModal = (type, faq = null) => {
        setModalType(type);
        if (type === 'edit' && faq) {
            setFormData({ title: faq.title, desc: faq.desc, order: faq.order || 0, id: faq._id });
        } else {
            setFormData({ title: '', desc: '', order: 0, id: null });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = { title: formData.title, desc: formData.desc, order: Number(formData.order) };

        if (modalType === 'add') {
            axios.post(CREATE_FAQ_ROUTE, payload, { headers: authHeader })
                .then(() => {
                    toast.success("FAQ added successfully!");
                    loadFaqs();
                    handleCloseModal();
                })
                .catch(error => {
                    console.error("Error adding FAQ:", error);
                    toast.error("Failed to add FAQ.");
                });
        } else {
            axios.put(UPDATE_FAQ_ROUTE(formData.id), payload, { headers: authHeader })
                .then(() => {
                    toast.success("FAQ updated successfully!");
                    loadFaqs();
                    handleCloseModal();
                })
                .catch(error => {
                    console.error("Error updating FAQ:", error);
                    toast.error("Failed to update FAQ.");
                });
        }
    };

    const handleDelete = (id) => {
        if (!window.confirm("Delete this FAQ?")) return;
        axios.delete(DELETE_FAQ_ROUTE(id), { headers: authHeader })
            .then(() => {
                setFaqs(faqs.filter(faq => faq._id !== id));
                toast.success("FAQ deleted successfully!");
            })
            .catch(error => {
                console.error("Error deleting FAQ:", error);
                toast.error("Failed to delete FAQ.");
            });
    };

    return (
        <>
            <div className="container">
                <div className="d-flex justify-content-between my-3">
                    <h2>FAQs</h2>
                    <Button onClick={() => handleOpenModal('add')} variant="primary" className="mb-3">Add FAQ</Button>
                </div>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Order</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {faqs.map((faq, index) => (
                            <tr key={faq._id}>
                                <td>{index + 1}</td>
                                <td>{faq.title}</td>
                                <td>{faq.desc}</td>
                                <td>{faq.order}</td>
                                <td>{faq.isActive ? 'Active' : 'Inactive'}</td>
                                <td>
                                    <Button variant="warning" size="sm" onClick={() => handleOpenModal('edit', faq)}>Edit</Button>{' '}
                                    <Button variant="danger" size="sm" onClick={() => handleDelete(faq._id)}>Delete</Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalType === 'add' ? 'Add FAQ' : 'Edit FAQ'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formTitle">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter title"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formDesc" className="mt-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Enter description"
                                name="desc"
                                value={formData.desc}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formOrder" className="mt-3">
                            <Form.Label>Order</Form.Label>
                            <Form.Control
                                type="number"
                                name="order"
                                value={formData.order}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="mt-3">
                            {modalType === 'add' ? 'Add FAQ' : 'Update FAQ'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            <ToastContainer />
        </>
    );
};

export default FAQs;
